(function(){
  const overlay=document.querySelector('[data-overlay]');
  function openDrawer(name){const drawer=document.querySelector('[data-drawer="'+name+'"]');if(!drawer)return;drawer.classList.add('is-open');drawer.setAttribute('aria-hidden','false');if(overlay)overlay.classList.add('is-open');document.body.style.overflow='hidden';if(name==='cart')refreshCart();}
  function closeDrawers(){document.querySelectorAll('[data-drawer]').forEach(d=>{d.classList.remove('is-open');d.setAttribute('aria-hidden','true')});if(overlay)overlay.classList.remove('is-open');document.body.style.overflow='';}
  document.addEventListener('click',e=>{const open=e.target.closest('[data-drawer-open]');const close=e.target.closest('[data-drawer-close]');if(open){e.preventDefault();openDrawer(open.dataset.drawerOpen)}if(close){e.preventDefault();closeDrawers()}if(e.target===overlay)closeDrawers()});
  document.querySelectorAll('[data-countdown]').forEach(el=>{const end=new Date(el.dataset.countdown).getTime();let timer;const tick=()=>{const d=Math.max(0,end-Date.now()),days=Math.floor(d/86400000),hours=Math.floor(d/3600000)%24,minutes=Math.floor(d/60000)%60,seconds=Math.floor(d/1000)%60;el.querySelector('[data-days]').textContent=String(days).padStart(2,'0');el.querySelector('[data-hours]').textContent=String(hours).padStart(2,'0');el.querySelector('[data-minutes]').textContent=String(minutes).padStart(2,'0');if(el.querySelector('[data-seconds]'))el.querySelector('[data-seconds]').textContent=String(seconds).padStart(2,'0');if(d===0&&timer)clearInterval(timer)};tick();if(end>Date.now())timer=setInterval(tick,1000)});
  document.querySelectorAll('[data-gallery]').forEach(gallery=>{const slides=[...gallery.querySelectorAll('.product-gallery__slides li')],thumbs=[...gallery.querySelectorAll('[data-gallery-thumb]')],index=gallery.querySelector('[data-gallery-index]');let active=0;const show=i=>{active=(i+slides.length)%slides.length;slides.forEach((s,n)=>s.classList.toggle('is-active',n===active));thumbs.forEach((t,n)=>t.classList.toggle('is-active',n===active));if(index)index.textContent=active+1};thumbs.forEach(t=>t.addEventListener('click',()=>show(Number(t.dataset.galleryThumb))));gallery.querySelector('[data-gallery-prev]')?.addEventListener('click',()=>show(active-1));gallery.querySelector('[data-gallery-next]')?.addEventListener('click',()=>show(active+1));show(0)});
  document.querySelectorAll('[data-scroll-reviews]').forEach(button=>button.addEventListener('click',()=>document.querySelector('#reviews')?.scrollIntoView({behavior:'smooth'})));
  async function enforceSingleItemCart(cart){
    cart=cart||await fetch('/cart.js',{headers:{Accept:'application/json'}}).then(r=>r.json());
    const items=cart.items||[];
    const needsFix=items.length>1 || (items[0]&&items[0].quantity!==1) || cart.item_count>1;
    if(!needsFix)return {cart,changed:false};
    const updates={};
    items.forEach((item,index)=>{updates[item.key]=index===0?1:0});
    const fixed=await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates})}).then(r=>r.json());
    return {cart:fixed,changed:true};
  }

  async function refreshCart(){
    const body=document.querySelector('[data-cart-body]'),footer=document.querySelector('[data-cart-footer]');
    if(!body)return;
    const res=await fetch('/cart.js');
    let cart=await res.json();
    cart=(await enforceSingleItemCart(cart)).cart;
    const money=n=>window.Shopify&&Shopify.formatMoney?Shopify.formatMoney(n):((n/100).toFixed(2)+' €');
    const paymentIcons=document.querySelector('[data-cart-payment-icons]')?.innerHTML||'';

    document.querySelectorAll('[data-cart-count],.cart-count').forEach(el=>el.textContent=cart.item_count);

    if(!cart.item_count){
      body.innerHTML='<div class="cart-drawer-empty"><span class="cart-drawer-empty__gift">🎁</span><h3>Votre panier est encore vide.</h3><p>Beauté, petits prix, enfants ou cadeaux : trouvez votre calendrier pour patienter jusqu\'à Noël.</p><a class="button button--dark button--full" href="/collections/all">Découvrir la collection</a></div>';
      footer.innerHTML='<div class="cart-drawer-noelia__empty-trust"><span>🔒 Paiement sécurisé</span><span>♡ 10% des bénéfices destinés à Présent pour Noël</span></div>';
      return;
    }

    const item=cart.items[0];
    body.innerHTML=
      '<article class="cart-drawer-item">'+
        '<a class="cart-drawer-item__image" href="'+item.url+'"><img src="'+item.image+'" alt=""></a>'+
        '<div class="cart-drawer-item__content">'+
          '<div class="cart-drawer-item__top">'+
            '<div><p class="cart-drawer-item__vendor">'+(item.vendor||'')+'</p><h3><a href="'+item.url+'">'+item.product_title+'</a></h3></div>'+
            '<strong>'+money(item.final_price)+'</strong>'+
          '</div>'+
          '<div class="cart-drawer-item__bottom"><span>Quantité : <b>1</b></span>'+
            '<button data-cart-remove data-key="'+item.key+'">Supprimer</button>'+
          '</div>'+
        '</div>'+
      '</article>'+
      '<p class="pdp-limit-note">1 calendrier maximum par commande.</p>'+
    '<a class="cart-drawer-noelia__cause" href="/pages/notre-engagement"><span>♡</span><div><b>Votre commande participe aussi à notre engagement</b><small>10% des bénéfices Noëlia sont destinés à Présent pour Noël.</small></div></a>';

    footer.innerHTML=
      '<div class="cart-drawer-noelia__summary">'+
        '<div class="cart-drawer-noelia__row"><span>Sous-total</span><strong>'+money(cart.total_price)+'</strong></div>'+
        '<div class="cart-drawer-noelia__row"><span>Livraison</span><strong class="is-free">Offerte</strong></div>'+
        '<div class="cart-drawer-noelia__total"><span>Total</span><strong>'+money(cart.total_price)+'</strong></div>'+
        '<small>Taxes incluses · Livraison offerte</small>'+
      '</div>'+
      '<a class="button button--dark button--full cart-drawer-noelia__checkout" href="/checkout">Finaliser ma commande · '+money(cart.total_price)+'</a>'+
      '<div class="cart-drawer-noelia__trust"><span>🔒 Paiement sécurisé</span><span>↻ Retours simples</span><span>✓ Sélection contrôlée</span></div>'+
      paymentIcons;
  }
  document.addEventListener('click',async e=>{const remove=e.target.closest('[data-cart-remove]');if(!remove)return;await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:remove.dataset.key,quantity:0})});refreshCart()});
  document.querySelectorAll('form[action="/cart/add"]').forEach(form=>form.addEventListener('submit',async e=>{
    e.preventDefault();
    const trigger=e.submitter||form.querySelector('button[type="submit"]');
    if(trigger){trigger.disabled=true;trigger.setAttribute('aria-busy','true');}
    try{
      await fetch('/cart/clear.js',{method:'POST',headers:{Accept:'application/json'}});
      const data=new FormData(form);
      data.set('quantity','1');
      const res=await fetch('/cart/add.js',{method:'POST',body:data,headers:{Accept:'application/json'}});
      if(!res.ok)throw new Error('Ajout panier impossible');
      if(typeof window.NOELIA_EXTERNAL_CHECKOUT==='function'){
        window.NOELIA_EXTERNAL_CHECKOUT(trigger);
      }else{
        window.location.href='/checkout';
      }
    }catch(err){
      console.error(err);
      if(trigger){trigger.disabled=false;trigger.removeAttribute('aria-busy');}
    }
  }));
  document.querySelector('[data-sticky-add]')?.addEventListener('click',()=>document.querySelector('[data-product-form] button[type="submit"]')?.click());

  enforceSingleItemCart().then(result=>{
    document.querySelectorAll('[data-cart-count],.cart-count').forEach(el=>el.textContent=result.cart.item_count?1:0);
    if(result.changed && document.querySelector('[data-single-cart-page]')) location.reload();
  }).catch(()=>{});

  document.querySelectorAll('[data-variant-pill]').forEach(button=>button.addEventListener('click',()=>{
    const form=button.closest('[data-product-form]');
    if(!form)return;
    form.querySelectorAll('[data-variant-pill]').forEach(b=>{b.classList.toggle('is-active',b===button);b.setAttribute('aria-pressed',b===button?'true':'false')});
    const hidden=form.querySelector('[data-variant-id]');
    if(hidden)hidden.value=button.dataset.variantId;
    const info=form.closest('.product-info');
    if(info){
      const price=info.querySelector('[data-pdp-price]');
      const compare=info.querySelector('[data-pdp-compare]');
      const discount=info.querySelector('[data-pdp-discount]');
      const edition=info.querySelector('[data-edition-label]');
      const atcPrice=info.querySelector('[data-atc-price]');
      if(price)price.textContent=button.dataset.variantPrice||'';
      if(compare)compare.textContent=button.dataset.variantCompare||'';
      if(discount)discount.textContent=button.dataset.variantDiscount?('-'+button.dataset.variantDiscount+'%'):'';
      if(edition)edition.textContent=button.dataset.variantTitle||'';
      if(atcPrice)atcPrice.textContent=button.dataset.variantPrice||'';
    }
    document.querySelectorAll('[data-sticky-price]').forEach(el=>el.textContent=button.dataset.variantPrice||'');
    document.querySelectorAll('[data-sticky-title]').forEach(el=>el.textContent=button.dataset.variantTitle||'');
  }));
  document.querySelectorAll('[data-qty-minus],[data-qty-plus]').forEach(btn=>btn.addEventListener('click',()=>{
    const wrap=btn.closest('.qty-stepper'),input=wrap?.querySelector('[data-qty-input]');
    if(!input)return;
    const value=Math.max(1,Number(input.value||1)+(btn.hasAttribute('data-qty-plus')?1:-1));
    input.value=value;
  }));


  document.querySelectorAll('[data-more-reviews]').forEach(button=>button.addEventListener('click',()=>{
    const section=button.closest('.pdp-reviews-v2');
    const extras=section?[...section.querySelectorAll('.pdp-review-extra')]:[];
    const expanded=button.getAttribute('aria-expanded')==='true';
    extras.forEach(card=>card.hidden=expanded);
    button.setAttribute('aria-expanded',expanded?'false':'true');
    button.textContent=expanded?'Voir plus d’avis':'Réduire les avis';
  }));

})();